var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("iconfont-symbol " + (_vm.className || '')),style:(_vm.styleObj),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }